var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVegIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 11.063C12.53 13.65 10.059 20 10.059 20C10.059 20 6.529 11.063 3 9",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4963 5.57936L20.9223 10.0034C21.1983 12.8734 19.0473 15.4284 16.1773 15.7054C13.3613 15.9754 10.8103 13.9174 10.5393 11.1014C10.4747 10.4317 10.5427 9.75596 10.7393 9.11261C10.936 8.46926 11.2574 7.87096 11.6854 7.35186C12.1133 6.83276 12.6392 6.40305 13.2332 6.08725C13.8272 5.77146 14.4776 5.57577 15.1473 5.51136L19.8633 5.05736C19.9391 5.05005 20.0156 5.05776 20.0885 5.08004C20.1614 5.10232 20.2291 5.13874 20.2879 5.18721C20.3467 5.23569 20.3954 5.29527 20.4311 5.36256C20.4669 5.42985 20.489 5.50352 20.4963 5.57936Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVegIcon);
export default __webpack_public_path__ + "static/media/vegIcon.d602c15cf4f97ec7c1aa40984541910b.svg";
export { ForwardRef as ReactComponent };